/**
 * Generated by orval v8.5.2 🍺
 * Do not edit manually.
 * VirtualBrain Chatbot API
 * API for chatbot interactions, authentication, and AI completions
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";


import { chatbotApiAxiosInstance } from "../../../../chatbot-api/axios-instance";
import type { BodyType, ErrorType } from "../../../../chatbot-api/axios-instance";
import type {
	ChatbotDto,
	ChatbotMessageDto,
	ChatbotPostQueryBody,
	ChatbotPostQueryResponse,
} from "../../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Retrieves chatbot configuration and metadata
 * @summary Get chatbot details
 */
export const chatbotControllerGetChatbotV1 = async (
	id: string,
	options?: SecondParameter<typeof chatbotApiAxiosInstance>,
	signal?: AbortSignal,
) => chatbotApiAxiosInstance<ChatbotDto>(
		{ url: `/v1/chats/${id}`, method: "GET", signal },
		options,
	);

export const getChatbotControllerGetChatbotV1QueryKey = (id: string) => [`/v1/chats/${id}`] as const;

export const getChatbotControllerGetChatbotV1QueryOptions = <
	TData = Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>,
	TError = ErrorType<void>,
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof chatbotApiAxiosInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getChatbotControllerGetChatbotV1QueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>> = async ({
		signal,
	}) => chatbotControllerGetChatbotV1(id, requestOptions, signal);

	return { queryKey, queryFn, enabled: Boolean(id), ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChatbotControllerGetChatbotV1QueryResult = NonNullable<
	Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>
>;
export type ChatbotControllerGetChatbotV1QueryError = ErrorType<void>;

export function useChatbotControllerGetChatbotV1<
	TData = Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>,
	TError = ErrorType<void>,
>(
	id: string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>,
					TError,
					Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof chatbotApiAxiosInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChatbotControllerGetChatbotV1<
	TData = Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>,
	TError = ErrorType<void>,
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>,
					TError,
					Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof chatbotApiAxiosInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChatbotControllerGetChatbotV1<
	TData = Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>,
	TError = ErrorType<void>,
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof chatbotApiAxiosInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get chatbot details
 */

export function useChatbotControllerGetChatbotV1<
	TData = Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>,
	TError = ErrorType<void>,
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof chatbotControllerGetChatbotV1>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof chatbotApiAxiosInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getChatbotControllerGetChatbotV1QueryOptions(id, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Retrieves all messages for a chatbot session
 * @summary Get conversation history
 */
export const chatbotControllerGetMessagesV1 = async (
	id: string,
	options?: SecondParameter<typeof chatbotApiAxiosInstance>,
	signal?: AbortSignal,
) => chatbotApiAxiosInstance<ChatbotMessageDto[]>(
		{ url: `/v1/chats/${id}/messages`, method: "GET", signal },
		options,
	);

export const getChatbotControllerGetMessagesV1QueryKey = (id: string) => [`/v1/chats/${id}/messages`] as const;

export const getChatbotControllerGetMessagesV1QueryOptions = <
	TData = Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>,
	TError = ErrorType<void>,
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof chatbotApiAxiosInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getChatbotControllerGetMessagesV1QueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>> = async ({
		signal,
	}) => chatbotControllerGetMessagesV1(id, requestOptions, signal);

	return { queryKey, queryFn, enabled: Boolean(id), ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChatbotControllerGetMessagesV1QueryResult = NonNullable<
	Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>
>;
export type ChatbotControllerGetMessagesV1QueryError = ErrorType<void>;

export function useChatbotControllerGetMessagesV1<
	TData = Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>,
	TError = ErrorType<void>,
>(
	id: string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>,
					TError,
					Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof chatbotApiAxiosInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChatbotControllerGetMessagesV1<
	TData = Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>,
	TError = ErrorType<void>,
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>,
					TError,
					Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof chatbotApiAxiosInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChatbotControllerGetMessagesV1<
	TData = Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>,
	TError = ErrorType<void>,
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof chatbotApiAxiosInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get conversation history
 */

export function useChatbotControllerGetMessagesV1<
	TData = Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>,
	TError = ErrorType<void>,
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof chatbotControllerGetMessagesV1>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof chatbotApiAxiosInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getChatbotControllerGetMessagesV1QueryOptions(id, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Sends a query and returns message metadata immediately. The AI-generated response is then streamed via Socket.io events (answering:message-update). This endpoint is designed for the chatbot frontend — for HTTP-based streaming, use /open-completion/{id}/query instead.
 * @summary Stream chatbot response (WebSocket)
 */
export const chatbotControllerQueryV1 = async (
	id: string,
	chatbotPostQueryBody: BodyType<ChatbotPostQueryBody>,
	options?: SecondParameter<typeof chatbotApiAxiosInstance>,
	signal?: AbortSignal,
) => chatbotApiAxiosInstance<ChatbotPostQueryResponse>(
		{
			url: `/v1/chats/${id}/query`,
			method: "POST",
			headers: { "Content-Type": "application/json" },
			data: chatbotPostQueryBody,
			signal,
		},
		options,
	);

export const getChatbotControllerQueryV1MutationOptions = <
	TError = ErrorType<void>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof chatbotControllerQueryV1>>,
		TError,
		{ id: string; data: BodyType<ChatbotPostQueryBody> },
		TContext
	>;
	request?: SecondParameter<typeof chatbotApiAxiosInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof chatbotControllerQueryV1>>,
	TError,
	{ id: string; data: BodyType<ChatbotPostQueryBody> },
	TContext
> => {
	const mutationKey = ["chatbotControllerQueryV1"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof chatbotControllerQueryV1>>,
		{ id: string; data: BodyType<ChatbotPostQueryBody> }
	> = async (props) => {
		const { id, data } = props ?? {};

		return chatbotControllerQueryV1(id, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ChatbotControllerQueryV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof chatbotControllerQueryV1>>
>;
export type ChatbotControllerQueryV1MutationBody = BodyType<ChatbotPostQueryBody>;
export type ChatbotControllerQueryV1MutationError = ErrorType<void>;

/**
 * @summary Stream chatbot response (WebSocket)
 */
export const useChatbotControllerQueryV1 = <TError = ErrorType<void>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof chatbotControllerQueryV1>>,
			TError,
			{ id: string; data: BodyType<ChatbotPostQueryBody> },
			TContext
		>;
		request?: SecondParameter<typeof chatbotApiAxiosInstance>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof chatbotControllerQueryV1>>,
	TError,
	{ id: string; data: BodyType<ChatbotPostQueryBody> },
	TContext
> => useMutation(getChatbotControllerQueryV1MutationOptions(options), queryClient);
